/**
 * Format a serialized sources string into a human-readable label.
 * Accepts the raw sources value from query history or saved searches.
 * Format: "s:source1,source2;l:logtype1,logtype2"
 * Returns: "source1", "2 Sources", "source1 · logtype1", "2 Sources · 3 logs", or ""
 */
export function formatSourcesLabel(raw) {
  if (!raw) return ''
  const str = typeof raw === 'string' ? raw : ''
  if (!str) return ''

  let sources = []
  let logs = []

  for (const seg of str.split(';')) {
    if (seg.startsWith('s:')) sources = seg.slice(2).split(',').filter(Boolean)
    else if (seg.startsWith('l:')) logs = seg.slice(2).split(',').filter(Boolean)
  }

  // Strip the src:/grp: disambiguation prefix for display.
  sources = sources.map(s => (s.startsWith('src:') || s.startsWith('grp:')) ? s.slice(4) : s)

  if (sources.length === 0 && logs.length === 0) return ''

  const parts = []
  if (sources.length === 1) parts.push(sources[0])
  else if (sources.length > 1) parts.push(`${sources.length} Sources`)
  if (logs.length === 1) parts.push(logs[0])
  else if (logs.length > 1) parts.push(`${logs.length} logs`)

  return parts.join(' \u00b7 ')
}
